/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../../google/protobuf/field_mask';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveCreditLineForMerchantRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "excludeSlowFields": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readMask": {
                    "type": ".google.protobuf.FieldMask",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCreditLineForMerchantResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditLineForMerchantRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditLineForMerchantResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCreditLineForMerchantRequest @ squareup/corporate_card/service/retrieve_credit_line_for_merchant.proto at 10:1
 */
export const RetrieveCreditLineForMerchantRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCreditLineForMerchantRequest');
fixType(RetrieveCreditLineForMerchantRequest);
Builder.createAndAttachToType(RetrieveCreditLineForMerchantRequest);
/**
 * SOURCE RetrieveCreditLineForMerchantResponse @ squareup/corporate_card/service/retrieve_credit_line_for_merchant.proto at 40:1
 */
export const RetrieveCreditLineForMerchantResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCreditLineForMerchantResponse');
fixType(RetrieveCreditLineForMerchantResponse);
Builder.createAndAttachToType(RetrieveCreditLineForMerchantResponse);